import axiosInstance from "../instance/axiosInstance";

class ProductsApi {
  static async productsList(page, productId, searchQuery) {
    let url = `/product-category/${productId}/product/list?page=${page}`;
    if (searchQuery) {
      url += `&search_value=${encodeURIComponent(searchQuery)}`;
    }
    try {
      const response = await axiosInstance.get(url);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }

  static async productsListWithoutPg() {
    try {
      const response = await axiosInstance.get(
        "/product-category/all-products/list"
      );
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }

  static async deleteProduct(categoryId, id) {
    try {
      const response = await axiosInstance.get(
        `/product-category/${categoryId}/product/delete/${id}`
      );
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }

  static async changeProductStatus(categoryId, formData) {
    try {
      const response = await axiosInstance.put(
        `/product-category/${categoryId}/product/status-update`,
        formData
      );
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async createProduct(categoryId, formData) {
    try {
      const response = await axiosInstance.post(
        `/product-category/${categoryId}/product/save`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async fetchProduct(categoryId, prodId) {
    try {
      const response = await axiosInstance.get(
        `/product-category/${categoryId}/product/view/${prodId}`
      );
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
}

export default ProductsApi;
